const nodeFiles = require.context('./', true, /\.js$/);
const nodes = [];
nodeFiles.keys().forEach((f) => {
  const [, key] = f.match(/\.\/(.+)\.js$/);
  const node = nodeFiles(f);
  if (key !== 'index') {
    nodes.push(node.default || node);
  }
});

export default nodes;
